import { Link } from "react-router-dom";

export const FitBand = () => {
  return (
    <section
      data-testid="fit-band"
      className="relative border-y-2 border-white bg-white py-10 text-black md:py-16"
    >
      <div className="mx-auto grid max-w-[1400px] grid-cols-12 gap-8 px-6 md:px-10">
        <div className="col-span-12 md:col-span-8">
          <span className="font-mono-stamp text-xs text-black/60">
            § 05 · FIND YOUR FIT
          </span>
          <h2 className="font-display mt-4 text-5xl leading-[0.88] md:text-7xl">
            NO GENDER.
            <br />
            JUST YOUR BODY.
          </h2>
          <p className="mt-6 max-w-xl font-mono-stamp text-xs leading-relaxed text-black/60">
            FORGET S / M / L AND THE ISLE THEY'RE ON. ANSWER 9 QUESTIONS ABOUT
            YOUR BODY. WE RETURN A SINGLE BAS1C SIZE CODE — STAMPED AND YOURS.
          </p>
        </div>
        <div className="col-span-12 flex items-end justify-center md:col-span-4 md:justify-end">
          <Link
            to="/find-your-fit"
            data-testid="fit-band-cta"
            className="btn-brutal !border-black !text-black hover:!bg-black hover:!text-white md:w-full md:justify-center"
          >
            START THE FIT ▸
          </Link>
        </div>
      </div>
    </section>
  );
};
